<template>
    <section>
        <div class="solicitation-info">
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.city.label }}</span>
                    <span v-if="payload.city.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <multiselect v-model="payload.city.value" :options="filteredCities" :searchable="true"
                    :clear-on-select="true" :allow-empty="true" :internal-search="false"
                    placeholder="⬇️ Selecione a cidade..." @search-change="searchOptions"
                    :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                    :selected-label="'Selecionado'">
                    <span slot="noResult">
                        Nenhum resultado encontrado
                    </span>
                    <span slot="noOptions">
                        Nenhum item disponível
                    </span>
                </multiselect>
            </div>
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.occurrenceDay.label }}</span>
                    <span v-if="payload.occurrenceDay.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input class="form-control" type="date" v-model="payload.occurrenceDay.value">
            </div>
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.occurrenceHour.label }}</span>
                    <span v-if="payload.occurrenceHour.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input class="form-control hour-input" type="time" v-model="payload.occurrenceHour.value">
            </div>
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.solicitantLicensePlate.label }}</span>
                    <span v-if="payload.solicitantLicensePlate.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input class="form-control" placeholder="AAA-1234" v-model="payload.solicitantLicensePlate.value"
                    v-mask="'XXX-XXXX'">
            </div>
        </div>
        <div class="base-info">
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.licensePlate.label }}</span>
                    <span v-if="payload.licensePlate.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <div class="input-with-button">
                    <input class="form-control" placeholder="AAA-1234" v-model="payload.licensePlate.value"
                        v-mask="'XXX-XXXX'">
                    <button v-if="!loading" class="form-control btn-primary" @click="checkPlate"><i
                            class="fas fa-search"></i> Buscar placa</button>
                    <button v-else class="form-control btn-primary" disabled><i class="fas fa-spinner fa-pulse"></i>
                        Buscando...</button>
                </div>
            </div>
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.prefix.label }}</span>
                    <span v-if="payload.prefix.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input class="form-control" placeholder="Prefixo" v-model="payload.prefix.value" v-mask="'#'">
            </div>
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.sufix.label }}</span>
                    <span v-if="payload.sufix.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input class="form-control" placeholder="Sufixo" v-model="payload.sufix.value" v-mask="'####'">
            </div>
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.baseName.label }}</span>
                    <span v-if="payload.baseName.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input class="form-control" placeholder="Nome da base do veículo" v-model="payload.baseName.value">
            </div>
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.baseAcronym.label }}</span>
                    <span v-if="payload.baseAcronym.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input class="form-control" placeholder="Sigla da base do veículo" v-model="payload.baseAcronym.value">
            </div>
        </div>
        <div class="custom-input-group">
            <div>
                <span>{{ payload.description.label }}</span>
                <span v-if="payload.description.required" class="required-field-indicator"
                    title="Campo obrigatório">*</span>
            </div>
            <textarea class="form-control" rows="3" placeholder="Descreva a reclamação..."
                v-model="payload.description.value"></textarea>
        </div>
        <div class="buttons-container">
            <button class="form-control" id="cancel-button" @click="cancel"><i class="fas fa-times"></i>
                Descartar</button>
            <button v-if="!saving" class="form-control" id="save-button" @click="save"><i class="fas fa-save"></i>
                Salvar</button>
            <button v-else class="form-control" id="save-button" disabled><i class="fas fa-spinner fa-pulse"></i>
                Salvando...</button>
        </div>
        <chooseBaseModal :bases="basesList" @base-selected="chooseBase($event)" :showModal="showChooseBaseModal"
            @close-choose-base-modal="closeBaseModal" />
    </section>
</template>

<script>
import { mask } from 'vue-the-mask';
import chooseBaseModal from './ChooseBaseModal.vue';
export default {
    directives: {
        mask
    },
    props: ['clientInfo', 'cities', 'saveLoading', 'reset'],
    components: {
        chooseBaseModal
    },
    data() {
        return {
            saving: false,
            loading: false,
            showChooseBaseModal: false,
            payload: {
                city: { label: 'Cidade', value: '', required: true },
                licensePlate: { label: 'Placa do veículo', value: '', required: false },
                solicitantLicensePlate: { label: 'Placa do solicitante', value: '', required: false },
                occurrenceDay: { label: 'Data da ocorrência', value: '', required: true },
                occurrenceHour: { label: 'Horário da ocorrência', value: '', required: true },
                prefix: { label: 'Prefixo', value: '', required: false },
                sufix: { label: 'Sufixo', value: '', required: false },
                baseName: { label: 'Nome da base', value: '', required: false },
                baseAcronym: { label: 'Sigla da base', value: '', required: false },
                description: { label: 'Descrição', value: '', required: true }
            },
            filteredCities: [],
            basesList: []
        }
    },
    computed: {},
    created() { },
    mounted() {
        this.filteredCities = [...this.cities];
    },
    methods: {
        searchOptions(query) {
            const keyword = query.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            if (!keyword) {
                this.filteredCities = [...this.cities];
                return;
            }

            this.filteredCities = this.cities.filter((item) =>
                item.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(keyword)
            );
        },
        async save() {
            this.$emit('save', { type: 'transito', data: this.payload })
        },
        async cancel() {
            Swal.fire({
                title: 'Descartar solicitação?',
                html: 'Deseja descartar as alterações feitas?',
                showCancelButton: true,
                confirmButtonText: 'Sim, descartar',
                cancelButtonText: 'Não, continuar editando',
                type: "question",
                showCloseButton: true,
                reverseButtons: true
            }).then(async result => {
                if (result.value) {
                    this.$emit('cancel')
                    await this.resetForm()
                }
            });
        },
        async resetForm() {
            this.payload = {
                city: { label: 'Cidade', value: '', required: true },
                licensePlate: { label: 'Placa do veículo', value: '', required: true },
                solicitantLicensePlate: { label: 'Placa do solicitante', value: '', required: true },
                occurrenceDay: { label: 'Data da ocorrência', value: '', required: true },
                occurrenceHour: { label: 'Horário da ocorrência', value: '', required: true },
                prefix: { label: 'Prefixo', value: '', required: false },
                sufix: { label: 'Sufixo', value: '', required: false },
                baseName: { label: 'Nome da base', value: '', required: false },
                baseAcronym: { label: 'Sigla da base', value: '', required: false },
                description: { label: 'Descrição', value: '', required: true }
            }
            this.chooseVehicleModal = false;
        },
        checkPlate() {
            if (!this.payload.licensePlate.value) {
                Swal.fire({
                    title: 'Digite a placa do veículo',
                    html: 'Para buscar informações do veículo, digite a placa',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    type: "warning",
                    showCloseButton: true
                })
                return
            }
            try {
                this.loading = true;
                axios.get(`${process.env.MIX_APP_URL}:4010/api/checkPlate`, { params: { plate: this.payload.licensePlate.value } }).then(({ data }) => {
                    if (data.length) {
                        if (data.length && data.length === 1) {
                            if (data[0].NomeBase) this.payload.baseName.value = data[0].NomeBase
                            if (data[0].SiglaBase) this.payload.baseAcronym.value = data[0].SiglaBase
                            if (data[0].Placa) this.payload.licensePlate.value = data[0].Placa
                            if (data[0].Prefixo) this.payload.prefix.value = data[0].Prefixo
                            if (data[0].Sufixo) this.payload.sufix.value = data[0].Sufixo
                        } else {
                            this.basesList = []
                            data.map(el => this.basesList.push(el))
                            this.showChooseBaseModal = true
                        }
                    } else {
                        Swal.fire({
                            title: 'Veículo não encontrado',
                            html: 'Não encontramos veículos com a placa informada.',
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            type: "warning",
                            showCloseButton: true
                        })
                    }
                }).finally(() => {
                    this.loading = false
                })
            } catch (error) {
                console.error('Erro ao buscar informações de veículo: ', error)
                this.loading = false
                Swal.fire({
                    title: 'Erro ao buscar veículo',
                    html: 'Ocorreu um erro ao buscar o veículo. Por favor, entre em contato com o admnistrador.',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    type: "warning",
                    showCloseButton: true
                })
            }
        },
        async chooseBase(data) {
            if (data.NomeBase) this.payload.baseName.value = data.NomeBase
            if (data.SiglaBase) this.payload.baseAcronym.value = data.SiglaBase
            if (data.Placa) this.payload.licensePlate.value = data.Placa
            if (data.Prefixo) this.payload.prefix.value = data.Prefixo
            if (data.Sufixo) this.payload.sufix.value = data.Sufixo
            this.basesList = []
            this.showChooseBaseModal = false
        },
        closeBaseModal() {
            this.basesList = []
            this.showChooseBaseModal = false
        }
    },
    watch: {
        saveLoading: {
            handler(value) {
                this.saving = value
            }
        },
        reset() {
            this.resetForm()
        }
    }
}
</script>

<style lang="scss" scoped>
.required-field-indicator {
    font-size: small;
    text-align: start;
    color: red;
}

.solicitation-info {
    display: flex;
    gap: 10px;
    min-height: 70px;
}

.base-info {
    display: flex;
    gap: 10px;
}

.custom-input-group {
    display: flex;
    flex-direction: column;
    text-align: start;
    width: 100%;
    justify-content: center;

    span {
        font-weight: bold;
    }

    textarea {
        resize: none
    }

    .input-with-button {
        display: flex;
        gap: 5px;
        height: 100%;
        align-items: center;

        button {
            border-radius: 10px !important;
            box-shadow: none;
        }
    }
}

.buttons-container {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    margin-bottom: 0;
    margin-top: 10px;

    button {
        width: fit-content;
        color: white;
        border-radius: 10px !important;
        box-shadow: none;
        transition: ease-in-out 0.2s
    }

    #save-button {
        background-color: darkgreen;

        &:hover {
            background-color: #023b02;
        }
    }

    #cancel-button {
        background-color: #a00404;

        &:hover {
            background-color: #6d0303;
        }
    }
}
</style>